<template>
	<div>
		<div v-if="resolvedComponent">
			<component
				:is="resolvedComponent"
				:data="data"
			/>
		</div>
		<div v-else class="component-error">
			<p>Component "{{ componentId }}" not found</p>
			<p v-if="isDev">
				Looking for: ./{{ componentId }}.vue<br>
				Available: {{ Object.keys(components).join(', ') }}
			</p>
		</div>

	</div>

</template>

<script setup>
const props = defineProps({
	componentId: {
		type: String,
		required: true
	},
	data: {
		type: Object,
		required: true
	}
});

const isDev = process.dev;

// Automatically import ALL .vue files from components directory
// This happens at build time, so it's SSR-compatible
const modules = import.meta.glob('./*.vue', { eager: true });

// Build component map automatically
const components = Object.entries(modules).reduce((componentArray, [path, module]) => {
	// Extract filename: ./Hero.vue -> Hero
	const componentName = path.replace('./', '').replace('.vue', '')
	// Skip self
	if (componentName === 'DynamicComponent') {
		return componentArray;
	}

	componentArray[componentName] = module.default;

	return componentArray;
}, {});

// Resolve component based on componentId
const resolvedComponent = computed(() => {
	const component = components[props.componentId]

	if (!component && isDev) {
		console.warn(`Component "${props.componentId}" not found. Available:`, Object.keys(components))
	}

	return component || null
});
</script>

<style scoped>
.component-error {
	padding: 2rem;
	background: #fee;
	color: #c00;
	border-radius: 4px;
	margin: 1rem 0;
}
</style>